<div class="d-flex justify-content-between align-items-center p-3" style="background: #F9FAFC;">
  <!-- Contador de filas -->
  <div class="items-pagination">
    <p>{{ totalRows === 0 ? 0 : startItem || 0 }} - {{ endItem || 0 }} de {{ totalRows || 0 }}</p>
  </div>

  <!-- Controles -->
  <div class="d-flex align-items-center">

    <!-- Selector de tamaño de página -->
    <div class="filas-pagina-pagination position-relative d-flex align-items-center">
      <p class="mb-0 me-2">Filas por página:</p>

      <div class="select-wrapper position-relative">
        <select
          [value]="pageSize"
          (change)="changePageSize($event)"
          class="form-select form-select-sm custom-select-arrow"
        >
          @for (size of pageSizes; track $index) {
            <option [value]="size">{{ size }}</option>
          }
        </select>
        <img src="assets/icons/arrow-down.svg" alt="" class="custom-arrow-icon" />
      </div>
    </div>

    <!-- Navegación -->
    <div class="control-pagination d-flex align-items-center ms-3">
      <button
        class="btn-pagination"
        type="button"
        (click)="onPreviousPage()"
        [disabled]="currentPage === 1"
      >
        <img src="assets/icons/arrow-back.svg" alt="Anterior" />
      </button>

      <div class="items-pagination px-2">
        <p class="mb-0">
          {{ currentPage === 0 ? 1 : currentPage }}/{{ totalPages === 0 ? 1 : totalPages }}
        </p>
      </div>

      <button
        class="btn-pagination"
        type="button"
        (click)="onNextPage()"
        [disabled]="currentPage >= totalPages || totalPages === 0"
      >
        <img src="assets/icons/arrow-next.svg" alt="Siguiente" />
      </button>
    </div>
  </div>
</div>
